<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <g fill="none" fill-rule="evenodd">
      <g>
        <g>
          <g>
            <g>
              <g transform="translate(-1026 -323) translate(983 195) translate(13 119) translate(30 9) translate(4 1.333)">
                <path
                  fill="#164194"
                  fill-rule="nonzero"
                  d="M0 7.014v19.663c0 1.286-.108 1.381 1.178 1.381h18.81c1.284 0 1.055.064 1.055-1.222V5.846c0-1.23.527-1.177-.68-1.17h-3.997V3.507v-.786c.003-.576-.01-.383-.603-.383H12.86C12.86 1.047 11.812 0 10.522 0 9.23 0 8.183 1.047 8.183 2.338h-2.64c-.643 0-.867-.003-.867.64v1.698H.446C0 4.676 0 5.172 0 7.014z"
                />
                <path fill="#E1F5FE" fill-rule="nonzero" d="M7.014 4.676H14.028V7.014H7.014z" />
                <path fill="#E1F5FE" fill-rule="nonzero" d="M2.338 25.72h16.368V7.013h-2.34v1.17c0 .642-.526 1.168-1.168 1.168H5.846c-.643 0-1.17-.526-1.17-1.169V7.014H2.338V25.72z" />
                <path
                  fill="#13A2E8"
                  fill-rule="nonzero"
                  d="M4.676 21.043H16.367V23.381H4.676zM13.72 11.479L11.352 11.478 11.352 13.817 8.715 13.817 8.715 11.478 6.377 11.478 6.377 13.817 6.377 16.155 6.377 18.493 8.715 18.493 8.715 16.155 11.403 16.155 11.403 18.493 13.669 18.493z"
                />
                <rect width="12.754" height="12.754" x="10.203" y="15.304" fill="#E1F5FE" rx="5" />
                <path
                  fill="#164194"
                  d="M16.58 14.029c4.226 0 7.652 3.426 7.652 7.652s-3.426 7.652-7.652 7.652-7.652-3.426-7.652-7.652 3.426-7.652 7.652-7.652zm0 2.55c-2.818 0-5.102 2.285-5.102 5.102 0 2.818 2.284 5.102 5.102 5.102 2.817 0 5.101-2.284 5.101-5.102 0-2.817-2.284-5.101-5.101-5.101z"
                />
                <path fill="#13A2E8" d="M16.58 19.13v2.55l2.55.001v1.276h-3.826V19.13h1.276z" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>